import React, { useEffect, memo, useState } from "react";
import {
    Switch,
    useColorModeValue,
    Tooltip,
    HStack,
    VStack,
    SimpleGrid,
    GridItem,
    Grid,
    Divider,
    Button,
    TagLabel,
    Tag,
    useDisclosure,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Flex,
    useMediaQuery,
    Checkbox,
    Box,
    Center,
    Text,
} from "@chakra-ui/react";
import { getAccount, getAuthUrl, updateUser } from "../../utils/sessionHelper";
import { useSession } from "next-auth/client";
import * as analytics from "../../utils/analytics";

export const AskAuth = ({callback=undefined as Function | undefined}) => {
    const [session, loading] = useSession();

    const isButtonDisabled = !session?.user?.uid || (session?.user?.uid != getAccount(session)?.idParent && session?.user?.uid != getAccount(session)?.id);
    let tooltipText = "You need to be logged in to do this";
    if (session?.user?.uid && session?.user?.uid != getAccount(session)?.idParent && session?.user?.uid != getAccount(session)?.id)
        tooltipText = "You can only do that from an account you own. Ask the owner of this account to do it.";
    
    return (
        <Box display="flex" justifyContent="center">
            <Center maxW="400px" mt={20} display="flex" flexDirection="column">
            <Text textStyle="body.medium.standard">To use this feature, you need to refresh your Twitter authorizations. Hit the button below to proceed.</Text>
            {
                !isButtonDisabled ? (
                    <Button mt={5} maxW="200px" variant={"primary"}
                        as="a"
                        href={getAuthUrl(session)}
                        target="_blank"
                        isDisabled={isButtonDisabled}
                        onClick={() => {
                            analytics.log("hit_getExtraAuth");

                            if (callback)
                                callback();
                        }}
                    >
                        Get extra auth
                    </Button>
                ) : (
                    <Tooltip shouldWrapChildren hasArrow label={tooltipText}>
                        <Button mt={5} maxW="200px" variant={"primary"}
                            isDisabled={true}
                        >
                            Get extra auth
                        </Button>
                    </Tooltip>
                )
            }
            </Center>
        </Box>
    )
}

